<template>
  <div :class="['navbar', 'cols', 'align-items-start', {active: isNavbarActive, 'mobile-navbar': supportMobile}]">
    <div class="router">
      <select
          class="language-menu borderless mobile"
          :value="$i18n.locale"
          @change="changeLocale($event.target.value)"
      >
        <option value="en">🇬🇧 English</option>
        <option value="bg">🇧🇬 Български</option>
        <option value="es">🇪🇸 Español</option>
      </select>
      <ul class="navbar-menu">
        <li v-if="checkRoutePermissions(paths.home)">
          <router-link :to="paths.home">
            <i class="bi bi-grid-1x2-fill mx-1"></i>
            {{ $t('navbar.main.home') }}
          </router-link>
        </li>
        <li v-if="isOazisCompany && checkRoutePermissions(paths.oazisSuppliersMap)">
          <router-link :to="paths.oazisSuppliersMap" class="nav-link text-dark">
            <i class="bi bi-geo-alt-fill mx-1"></i>
            {{ $t('navbar.oazis-suppliers-map') }}
          </router-link>
        </li>
        <li v-if="checkRoutePermissions(paths.trips)">
          <router-link :to="paths.trips" class="nav-link text-dark">
            <i class="bi bi-file-earmark-check mx-1"></i>
            {{ $t('navbar.reports.trips') }}<span class="attention-banner text-white ml-5">NEW</span>
          </router-link>
        </li>
        <li v-if="checkRoutePermissions(paths.events)">
          <router-link :to="paths.events" class="nav-link text-dark">
            <i class="bi bi-bell mx-1"></i>
            {{ $t('navbar.reports.events') }}
          </router-link>
        </li>
        <li v-if="checkRoutePermissions(paths.garage)">
          <router-link :to="paths.garage" class="nav-link text-dark">
            <i class="bi bi-calendar-check"></i>
            {{ $t('navbar.garage') }}
          </router-link>
        </li>
        <li v-if="checkRoutePermissions(paths.admin.onBoard)">
          <router-link :to="paths.admin.onBoard" class="nav-link text-dark">
            <i class="bi bi-people"></i>
            {{ $t('navbar.settings.on-board') }}
          </router-link>
        </li>
        <li v-if="checkRoutePermissions(paths.carFleet)">
          <router-link :to="paths.carFleet" class="nav-link text-dark">
            <i class="bi bi-sliders2 mx-1"></i>
            {{ $t('navbar.settings.car-fleet') }}
          </router-link>
        </li>
        <li v-if="userCompany !== null && checkRoutePermissions(paths.client)">
          <router-link :to="paths.client" class="nav-link text-dark">
            <i class="bi bi-people"></i>
            {{ $t('navbar.settings.client') }}
          </router-link>
        </li>
        <li v-if="checkRoutePermissions(paths.geoFences)">
          <router-link :to="paths.geoFences" class="nav-link text-dark">
            <i class="bi bi-textarea mx-1"></i>
            {{ $t('navbar.geo-fences') }}
          </router-link>
        </li>
        <li v-if="checkRoutePermissions(paths.reports)">
          <router-link :to="paths.reports" class="nav-link text-dark">
            <i class="bi bi-journals mx-1"></i>
            {{ $t('navbar.reports') }}<span class="attention-banner text-white ml-5">NEW</span>
          </router-link>
        </li>
        <li class="accordion-as-li">
        <Accordion v-if="checkRoutePermissions(paths.tasks.root)">
          <template #title class="nav-link text-dark">
            <i class="bi bi-ui-checks mx-1"></i>
            {{ $t('navbar.task-planner') }}<span class="attention-banner tasks-attention-banner text-white ml-5">NEW</span>
          </template>
          <template #content>
              <li v-if="isOazisCompany">
                <button type="button" class="nav-menu-button text-dark width-100p" @click="syncOazisDaily">
                  <i class="bi bi-arrow-repeat mx-1"></i>
                  {{ $t('task.oazis.sync') }}
                </button>
              </li>
              <li>
                <router-link :to="paths.tasks.new" class="nav-link text-dark">
                  <i class="bi bi-plus-square mx-1"></i>
                  {{ $t('navbar.task-planner.new') }}
                </router-link>
              </li>
              <li>
                <router-link :to="paths.tasks.all" class="nav-link text-dark">
                 <i class="bi bi-plus-square mx-1"></i>
                 {{ $t('navbar.task-planner.all') }}
                </router-link>
              </li>
              <li>
                <router-link :to="paths.tasks.schedules" class="nav-link text-dark">
                 <i class="bi bi-calendar-week mx-1"></i>
                 {{ $t('navbar.task-planner.schedules') }}
                </router-link>
              </li>
          </template>
        </Accordion>
        </li>
      </ul>
    </div>
    <div class="contact cols align-items-start">
      <div class="contact-container">
        <a :href="linkEmail">
          <i class="bi bi-envelope"></i>
          {{ $t('navbar.contact.email') }}
        </a>
      </div>

      <div class="who-am-i rows justify-space-between align-items-center">
        <div class="avatar">
          <img src="@/assets/images/navbar/avatar.png" :alt="userName">
        </div>
        <div class="avatar-title cols align-items-start">
          <span class="avatar-title-name">
            {{ userName }}
          </span>
          <a href="#" class="avatar-title-logout" @click="logout">
            <i class="bi bi-door-closed-fill"></i>
            {{ $t('navbar.user.logout') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {actions, mutations} from '@/assets/js/vue/vuex/actions';
import paths from '@/assets/js/vue/router/paths';
import notification from '@/assets/js/notification';
import Accordion from "@/components/pages/partials/Accordion.vue";
import usersConfig from "@/assets/js/users-config.ts";

export default {
  name: 'NavBar',
  components: {Accordion},
  props: {
    isNavbarActive: {
      type: Boolean,
      default: false,
    },
    supportMobile: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      paths: paths
    }
  },
  computed: {
    ...mapState(['session']),
    ...mapGetters(['isAdmin', 'isOazisCompany', 'userCompany', 'userId']),
    userName: function() {
      return this.session.name || this.$t('header.anonymous');
    },
    linkPhone() {
      return 'tel:' + this.$t('navbar.contact.phone').replaceAll(' ', '');
    },
    linkEmail() {
      return 'mailto:' + this.$t('navbar.contact.email');
    },
  },
  methods: {
    changeLocale(newLocale) {
      this.$store.commit(mutations.SET_LOCALE, newLocale);
    },
    logout() {
      this.$store.dispatch(actions.CLOSE_SESSION).then(() => {
        this.$router.push(paths.auth);
      }).catch(e => notification.error(this.$t(e.message)));
    },
    syncOazisDaily() {
      this.$store.dispatch(actions.SYNC_OAZIS_DAILY)
          .then(() => {
            notification.success(this.$t('task.oazis.sync.success'));
            return this.$store.dispatch(actions.GET_TASKS);
          })
          .catch(e => notification.error(this.$t(e.message)));
    },
    checkRoutePermissions(route) {
      return usersConfig.isPathAllowed(this.userId, route);
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.attention-banner {
  background-color: green;
  margin-left: 5px;
  font-size: x-small;
  position: absolute;
  height: 24px;
  border-radius: 50%;
  width: 46px;
  margin-top: -5px;
  text-align: center;
  font-weight: bold;
}

.tasks-attention-banner {
  position: inherit;
}

.navbar {
  .router {
    width: 100%;

    .navbar-menu {
      width: 100%;

      .accordion {
        border: #6a11cb;
      }
      li {
        width: 100%;

        a,
        .nav-menu-button {
          display: block;
          width: calc(100% - 48px);
          height: 100%;
          padding: 16px 24px;
          margin-bottom: 15px;

          border: none;
          background: transparent;
          text-decoration: none;
          text-align: left;
          cursor: pointer;

          color: $default-text-color;
          font-weight: 400;
          font-size: 1rem;
          line-height: 24px;

          i {
            margin-right: 10px;

            font-size: 1.2rem;
            color: #33449c;
          }
        }

        & a.router-link-active {
          background: linear-gradient(135.57deg, #FA57EE 3.72%, #B650D2 42.15%, #794BB9 75.92%, #33449C 115.52%);
          border-radius: 15px;

          color: white;

          i {
            color: white;
          }
        }
      }
    }
  }

  .contact {
    width: 100%;
    margin-top: 100px;

    .contact-container {
      width: calc(100% - 48px);
      padding: 16px 24px;

      background: $tracking-blue;
      border-radius: 16px;

      a {
        display: inline-block;
        width: 100%;

        text-decoration: none;

        color: $default-text-color;
        font-weight: 400;
        font-size: 1rem;
        line-height: 24px;

        i {
          margin-right: 10px;

          font-size: 1.2rem;
          color: #33449c;
        }

        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }
    }

    .who-am-i {
      height: 50px;
      margin-top: 50px;

      .avatar {
        height: 100%;

        & > img {
          height: 100%;
        }
      }

      .avatar-title {
        margin-left: 12px;

        .avatar-title-name {
          margin-bottom: 5px;

          color: $default-text-color;
          font-weight: 500;
          font-size: 1.2rem;
        }

        .avatar-title-logout {
          text-decoration: none;

          color: $default-text-color;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 18px;

          i {
            font-size: 1.2rem;
            color: #33449c;
          }
        }
      }
    }
  }
}

// Desktop:
@media (min-width: $breaking-point + 1) {
  .navbar {
    float: left;
    width: ($desktop-sidebar-width - 60px);
    padding: 30px;
  }
}

// Mobile:
@media (max-width: $breaking-point) {
  .navbar {
    .language-menu {
      width: 100%;
      margin-bottom: 30px;

      font-size: 1.2rem;
    }

    &.mobile-navbar {
      position: fixed;
      overflow-y: scroll;

      top: $header-strip-height;
      right: -100%;

      width: calc(100% - 20px);
      height: calc(100% - $header-strip-height - 20px);
      padding: 10px;

      background: white;
      z-index: 10;

      transition: all 0.4s;

      &.active {
        right: 0;
      }
    }
  }
}
</style>
